// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Share } from 'shared_components/common/share/Share';
import { generateSrcForCDN } from 'shared_components/common/artdirection/picture/Picture';

import { artistShareCls } from 'shared_components/artist/share/Share.less';

type Props = {
  name: string,
  url: string,
  image: Object,
};

export const ArtistShare = ({ name, url, image }: Props) => (
  <Share
    className={artistShareCls}
    contentKey="artistProfile"
    contentValues={{ artist: name, url }}
    theme="dark"
    buttonText={<FormattedMessage id="common.share" />}
    url={url}
    image={generateSrcForCDN({ ...image, width: 1200, height: 'AUTO' })}
  />
);
